import { ProgressBars } from '@domgen/base-design-system-2.0/molecules/ProgressBars';

export function ModelNumberPage() {
  return (
    <>
      <div className="flex justify-center items-center my-8">
        <div className="w-2xl h-auto p-5 flex flex-col justify-center rounded-(--border-radius) bg-neutral-0">
          <ProgressBars total={6} current={2} />

          <h1>Model Number?</h1>
        </div>
      </div>
    </>
  );
}
